export const wpImageClass = 'wp-block-image';
export const wpOrnamentalImageClass = 'cdm-ornamental-image-block';
